"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var ItemHelper_1 = require("../customDetailList/ItemHelper");
var SearchParameters_1 = require("./SearchParameters");
function searchComboBoxReducer(state, action) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    var newPageInfo;
    switch (action.type) {
        case 'FilterPanelToggle':
            return __assign(__assign({}, state), { filterVisible: (_a = action.payload.visible) !== null && _a !== void 0 ? _a : ((_b = state.filterVisible) !== null && _b !== void 0 ? _b : false) });
        case 'ChangeDirection':
            return __assign(__assign({}, state), { rtl: action.payload.rtl });
        case 'receivedNewItems':
            newPageInfo = ItemHelper_1.BuildPagination((_e = (_d = (_c = state.pageInfo) === null || _c === void 0 ? void 0 : _c.paginationSetting) === null || _d === void 0 ? void 0 : _d.initialPage) !== null && _e !== void 0 ? _e : 0, action.payload.items, (_f = state.pageInfo) === null || _f === void 0 ? void 0 : _f.paginationSetting);
            return __assign(__assign({}, state), { items: action.payload.items, itemsView: ItemHelper_1.pagination(action.payload.items, newPageInfo), pageInfo: newPageInfo });
        case 'Select':
            return __assign(__assign({}, state), { isSelected: true, searchText: action.payload.text, saveSearchText: state.searchText });
        case 'unSelect':
            if (state.isSelected) {
                var param = new SearchParameters_1.SearchParameter((_g = state.filters) !== null && _g !== void 0 ? _g : [], state.saveSearchText, state.rtl);
                return __assign(__assign({}, state), { searchText: (_h = state.saveSearchText) !== null && _h !== void 0 ? _h : state.searchText, isSelected: false, saveSearchText: undefined, criterias: param.criterias, editCriterias: param.criterias, primaryText: param.primaryText, hasCriterias: param.hasCritieras });
            }
            return (state);
        case 'Clear': {
            var clearCtierias = (_j = state.criterias) === null || _j === void 0 ? void 0 : _j.map(function (m) { return { name: m.name, value: undefined, definition: m.definition }; });
            return __assign(__assign({}, state), { items: undefined, itemsView: undefined, searchText: '', primaryText: '', criterias: clearCtierias, editCriterias: clearCtierias, hasCriterias: false });
        }
        case 'DeclareFilter': {
            var param = new SearchParameters_1.SearchParameter((_k = action.payload.filters) !== null && _k !== void 0 ? _k : [], state.searchText, state.rtl);
            return __assign(__assign({}, state), { filters: action.payload.filters, searchText: state.searchText, criterias: param.criterias, editCriterias: param.criterias, primaryText: param.primaryText, hasCriterias: param.hasCritieras });
        }
        case 'ChangeSearch': {
            if (state.isSelected === false) {
                var param = new SearchParameters_1.SearchParameter((_l = state.filters) !== null && _l !== void 0 ? _l : [], action.payload.searchText, state.rtl);
                return __assign(__assign({}, state), { searchText: action.payload.searchText, criterias: param.criterias, editCriterias: param.criterias, primaryText: param.primaryText, hasCriterias: param.hasCritieras });
            }
            return (state);
        }
        case 'UpdateCriteria': {
            var copy = state.editCriterias ? __spreadArrays(state.editCriterias) : [];
            var item = copy.find(function (c) { return c.name === action.payload.name; });
            if (item) {
                item.value = action.payload.value;
                return __assign(__assign({}, state), { editCriterias: copy });
            }
            return (state);
        }
        case 'ApplyCriterias': {
            var param = new SearchParameters_1.SearchParameter((_m = state.filters) !== null && _m !== void 0 ? _m : [], state.searchText, state.rtl);
            param.criterias = (_o = state.editCriterias) !== null && _o !== void 0 ? _o : [];
            return __assign(__assign({}, state), { criterias: state.editCriterias, hasCriterias: param.hasCritieras, searchText: param.toString(), filterVisible: false });
        }
        case 'CancelCriterias': {
            return __assign(__assign({}, state), { editCriterias: state.criterias, filterVisible: false });
        }
        case 'pageSettingChanged':
            if (action.paginationSetting) {
                newPageInfo = ItemHelper_1.BuildPagination((_q = (_p = action.paginationSetting) === null || _p === void 0 ? void 0 : _p.initialPage) !== null && _q !== void 0 ? _q : 0, state.items, __assign(__assign({}, action.paginationSetting), { totalPage: action.paginationSetting.totalPage, nbItemPerPage: (_r = action.paginationSetting) === null || _r === void 0 ? void 0 : _r.nbItemPerPage }));
            }
            else {
                newPageInfo = undefined;
            }
            return __assign(__assign({}, state), { itemsView: ItemHelper_1.pagination(state.items, newPageInfo), pageInfo: newPageInfo });
        case 'beginNav':
        case 'endNav':
        case 'pageNav':
            if (state.pageInfo) {
                switch (action.type) {
                    case 'beginNav':
                        newPageInfo = __assign(__assign({}, state.pageInfo), { currentPage: 0 });
                        break;
                    case 'endNav':
                        newPageInfo = __assign(__assign({}, state.pageInfo), { currentPage: state.pageInfo.totalPage - 1 });
                        break;
                    case 'pageNav':
                        newPageInfo = __assign(__assign({}, state.pageInfo), { currentPage: action.pageNumber });
                        break;
                    default:
                        throw new Error('navigation page action invalid');
                }
                return __assign(__assign({}, state), { itemsView: ItemHelper_1.pagination(state.items, newPageInfo), pageInfo: newPageInfo });
            }
            return __assign(__assign({}, state), { itemsView: ItemHelper_1.pagination(state.items) });
        default:
            break;
    }
    return (state);
}
exports.searchComboBoxReducer = searchComboBoxReducer;
//# sourceMappingURL=Reducer.js.map